import React, { CSSProperties, useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, MenuItem, Menu, Icon, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link, NavLink } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';

const Navbar = () => {

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleMobileMenuOpen = (event: any) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const mobileMenuId = 'primary-search-account-menu-mobile';

  const navItems = [
    { to: '/', text: 'Home' },
    { to: '/aboutus', text: 'About Us' },
    { to: '/trips', text: 'Trips' },
    { to: '/contactus', text: 'Contact Us' },
    { to: '/membership', text: 'Membership' },
    { to: '/events', text: 'Events' },
    { to: '/links', text: 'Links' },
  ];

  const renderMobileMenu = (
    <Drawer
      anchor='right'
      open={Boolean(mobileMoreAnchorEl)}
      onClose={() => setMobileMoreAnchorEl(null)}
      PaperProps={{ 
        style: { 
          width: '80%', // Set the width of the Drawer
          backgroundImage: `url(${process.env.PUBLIC_URL + '/images/winter_blue_background.jpg'})`, // Set the background image
          backgroundSize: 'cover', // Cover the entire area of the Drawer
        },
      }}
    >
      <IconButton
        edge="end"
        color="inherit"
        onClick={() => setMobileMoreAnchorEl(null)}
        sx={{ position: 'absolute', right: '15px', top: 0 }} // Add a right margin
      >
        <CloseIcon />
      </IconButton>

      {navItems.map((item, index) => (
        <Link className='mobile-link-navbar' to={item.to}>
          <MenuItem onClick={() => setMobileMoreAnchorEl(null)} style={{ marginTop: index === 0 ? '50px' : '0' }}>
            {item.text}
          </MenuItem>
        </Link>
      ))}
    </Drawer>
  );

  return (
    <div>
      <AppBar position="static" style={{ position: 'relative', height: '80px', backgroundColor: '#28364b' }}>
        <Toolbar style={{ justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="logo"
            className='logo'
            onClick={() => window.location.href = '/'}
          >
            <img src="/images/logo.svg" alt="Logo" style={{ height: '60px', width: '60px' }} />
          </IconButton>
          {isMobile ? (
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={handleMobileMenuOpen}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                {navItems.map((item, index) => (
                  <Typography key={index} variant="h6" style={{ marginRight: theme.spacing(2) }}>
                    <NavLink
                      className={({ isActive, isPending }) => (isActive ? 'active-link-navbar' : isPending ? 'active-link-navbar' : 'link-navbar')}
                      to={item.to || ""}>{item.text}
                    </NavLink>
                  </Typography>
                ))}
              </div>
            </div>
          )}
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
    </div>
  );
};

export default Navbar;
